<template>
  <div class="h-screen flex flex-col bg-gray-100 dark:bg-gray-900">
    <!-- Header -->
    <header class="w-full h-16 bg-gradient-to-r from-blue-700 dark:from-gray-950 dark:to-gray-950 to-blue-700 shadow-md flex items-center justify-between px-6">
      <span @click="$store.state.toggleSideBar = !$store.state.toggleSideBar" class="cursor-pointer fd:hidden">
        <font-awesome-icon icon="bars" class="text-white  text-2xl cursor-pointer" />
      </span>
      <h1 class="text-xl font-bold text-white  tracking-wide fm:text-xs">داشبورد</h1>

      <div class="flex items-center gap-4">
         <button 
            class="relative py-2 px-3 rounded-lg hover:bg-blue-500 dark:hover:bg-gray-800 transition"
            @click="toggleDarkMode"
        >
            <font-awesome-icon :icon="isDark ? 'moon' : 'sun'" :class="['text-white text-xl fm:text-sm', isDark ? 'text-blue-400' : 'text-yellow-400']" />
        </button>
        <!-- <button class="relative py-2 px-3 rounded-lg hover:bg-blue-500 dark:hover:bg-gray-800 transition">
          <font-awesome-icon icon="bell" class="text-white " />
          <span class="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
        </button> -->
        <div class="relative group">
          <img
            :src="$store.state.baseApiUrl + $store.state.user.avatar"
            alt="user"
            class="w-10 h-10 rounded-full border-2 border-white shadow-md cursor-pointer"
          />
          <!-- Dropdown -->
          <div
            class="absolute left-0 mt-2 w-40 bg-white dark:bg-gray-950 dark:shadow-gray-800 shadow-lg rounded-xl opacity-0 group-hover:opacity-100 transition p-2"
          >
            <routerLink
              :to="{name:'Profile'}"
              class="block px-3 py-2 text-center rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-700 dark:text-white transform duration-300 ease-in-out"
            >پروفایل</routerLink>
            <Button text="خروج" @click="logout" class="w-full" :btnLoading="btnLoading" my_class="dark:!bg-gray-950 dark:hover:!bg-gray-800 dark:!text-white !w-full !bg-white hover:!bg-gray-100 !text-gray-700"/>
          </div>
        </div>
      </div>
    </header>

    <!-- Body -->
    <div class="flex flex-1 overflow-hidden">
      <!-- Sidebar -->
      <aside :class="['w-64 bg-white dark:bg-gray-950 shadow-lg overflow-auto h-full py-5 flex flex-col gap-6 border-r fd:block', $store.state.toggleSideBar ? 'block' : 'hidden']">
        <ul class="flex flex-col gap-2 w-full" v-if="isAdmin">
            <DashboardSidebar
                :menuId="1"
                title="داشبورد"
                icon="home"
                route="Dashboard"
            />

            <DashboardSidebar
                :menuId="1"
                title="نقش  و دسترسی ها"
                icon="universal-access"
                :badgeCount="0"
                :subMenus="[
                    { title: 'لیست نقش ها', routeName: 'Role', perm: '' },
                    { title: 'لیست دسترسی ها', routeName: 'Permission', perm: '' }
                ]"
            />

            <DashboardSidebar
                v-if="hasPermission(['users'])"
                :menuId="2"
                title="کاربران"
                icon="users"
                :badgeCount="0"
                :subMenus="[
                    { title: 'لیست کاربران', routeName: 'User', perm: 'users' },
                ]"
            />

            <DashboardSidebar
                v-if="hasPermission(['templates'])"
                :menuId="2"
                title="لینک ها"
                icon="link"
                :badgeCount="0"
                :subMenus="[
                    { title: 'لیست لینک ها', routeName: 'Template', prem:'templates'},
                ]"
            />

        </ul>

        <ul class="flex flex-col gap-2 w-full" v-if="isCustomer">
            <DashboardSidebar
                :menuId="1"
                title="داشبورد"
                icon="home"
                route="Dashboard"
            />

            <DashboardSidebar
                :menuId="2"
                title="لینک ها"
                icon="link"
                :badgeCount="0"
                :subMenus="[
                    { title: 'لیست لینک ها', routeName: 'Template'},
                ]"
            />
        </ul>
         <ul class="flex flex-col">
            <DashboardSidebar
                :menuId="2"
                title="پروفایل"
                icon="user"
                :badgeCount="0"
                :subMenus="[
                    { title: 'پروفایل', routeName: 'Profile'},
                    { title: 'تغییر رمز عبور', routeName: 'ChangePassword'},
                ]"
            />
          </ul>
      </aside>

      <!-- Main Content -->
      <main class="flex-1 p-6 overflow-y-auto">
        <router-view/>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardLayout',
};
</script>

<script setup>
import { onMounted, ref, watch } from 'vue';
import DashboardSidebar from '@/components/DashboardSidebar.vue';
import Button from '@/components/Button.vue';
import { useRouter } from "vue-router";
import axios from '@/plugins/axios';
import store from '@/store';
import Toast from '@/plugins/toast';

const router = useRouter();
let isDark = ref(false);
let btnLoading = ref(false)
let isAdmin = ref(store.state.user.access === 'admin')
let isCustomer = ref(store.state.user.access === 'customer')

onMounted(() => {
    if (localStorage.getItem('dark-mode') === 'true') {
        isDark.value = true
        document.documentElement.classList.add('dark')
    } else {
        isDark.value = false
        document.documentElement.classList.remove('dark')
    }
    getDashboardData()
})

async function getDashboardData(){
  await axios.get(`${store.state.apiUrl}dashboard-data`).then(resp=>{
    let data = resp.data.data;
    store.state.userPermissions = data.permissions;
  }).catch(err=>{
    store.commit('handleError', err)
  })
}

async function logout(){
  btnLoading.value = true;
  await axios.post('/api/logout').then(resp=>{
      Toast.success("خروج با موفقیت انجام شد")
      store.commit("clearStorage")
      setTimeout(()=>{
        router.push({name:'Index'})
      },500)
  }).catch(err=>{
    store.commit('handleError', err)
  })
  btnLoading.value = false;
}


function toggleDarkMode() {
    isDark.value = !isDark.value
    localStorage.setItem('dark-mode', isDark.value)
    if (isDark.value) {
        document.documentElement.classList.add('dark')
    } else {
        document.documentElement.classList.remove('dark')
    }
}

function hasPermission(_permissions){
  let existPerms = [];
  for(let i = 0; i < _permissions.length; i++){
    for(let j = 0; j < store.state.userPermissions.length; j++){
      if(store.state.userPermissions[j].search(_permissions[i]) > 0){
        existPerms.push(true);
      }
    }
  }
  return existPerms.filter(item=>item).length > 0;
}

</script>